exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".suffix ~ input {\n  padding-right: 3rem;\n  width: calc(100% - 3rem); }\n\n.suffix {\n  position: absolute;\n  right: 1rem;\n  color: lightgray;\n  line-height: 3rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/forms/limit/limit.component.scss
// module id = ../../../../../src/app/pages/dashboard/forms/limit/limit.component.scss
// module chunks = main